
import { computed, defineComponent, reactive, ref, watch } from 'vue';
import OpenOtherApi from '@/api/OpenOtherApi'
import RoleSelect from '@/components/common/RoleSelect.vue';
import ServiceDeskTagSelect from '@/components/common/ServiceDeskTagSelect.vue';
import ServiceDeskSelect from '@/components/common/ServiceDeskSelect.vue';
import EweiTagsSelect from '@/components/common/EweiTagsSelect.vue';
import { RuleObject, useForm } from 'ant-design-vue/lib/form';
import { isPositiveInteger } from '@/utils/tool.util';
import { message } from 'ant-design-vue';
import { ProviderModule } from '@/store/modules/provider.module';

export default defineComponent({
  components: {
    RoleSelect,
    ServiceDeskTagSelect,
    ServiceDeskSelect,
    EweiTagsSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectedAccounts: {
      type: Array,
      default: () => []
    },
    hadSunloginWeb: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const showModal = computed({
      get () {
        return props.visible
      },
      set (value) {
        emit('update:visible', value)
      }
    })

    const formData = reactive<any>({
      defaultServiceDesk: { id: null },
      minConcurrentChatNumber: 1,
      maxConcurrentChatNumber: 10,
      role: { id: null },
      serviceDeskIds: [],
      user: {}
    })
    const selectedTags = ref<any []>([])
    const currentRoleNameKey = computed(() => ProviderModule.engineer.role.nameKey) // 当前客服身份
    const filterRoleNameKey = computed(() => {
      if (
        currentRoleNameKey.value === 'ROLE_NAME_CREATOR' ||
        currentRoleNameKey.value === 'ROLE_NAME_ADMIN'
      ) {
        return ['ROLE_NAME_CREATOR']
      } else {
        return ['ROLE_NAME_CREATOR', 'ROLE_NAME_ADMIN']
      }
    })
    // 可选首选客服组ids
    const serviceDeskOptionIds = computed(() => {
      if (props.hadSunloginWeb) {
        let defaultServiceDeskId = ''
        props.selectedAccounts.forEach((account: any, index: number) => {
          if (index === 0) {
            defaultServiceDeskId = account.defaultServiceDeskId
          } else if (defaultServiceDeskId !== account.defaultServiceDeskId) {
            defaultServiceDeskId = ''
          }
        })
        if (defaultServiceDeskId) {
          return [defaultServiceDeskId]
        }
        return []
      }
      return formData.serviceDeskIds
    })

    const checkMinChatNumber = async (rule: RuleObject, value: string) => {
      if (!isPositiveInteger(value)) {
        return Promise.reject('下范围需大于0的正整数')
      }
      if (Number(value) > Number(formData.maxConcurrentChatNumber)) {
        return Promise.reject('下范围需小于等于上范围')
      }
      return Promise.resolve()
    }
    const checkMaxChatNumber = async (rule: RuleObject, value: string) => {
      if (!isPositiveInteger(value)) {
        return Promise.reject('上范围需为大于0的正整数')
      }
      if (Number(value) > 9999) {
        return Promise.reject('上范围不能大于 9999')
      }
      if (Number(formData.minConcurrentChatNumber) > Number(value)) {
        return Promise.reject('上范围需大于等于下范围')
      }
      return Promise.resolve()
    }
    const rules = reactive({
      'role.id': [
        { required: true, message: '请选择用户角色', trigger: 'blur' }
      ],
      'defaultServiceDesk.id': [
        { required: true, message: '请选择首选客服组', trigger: 'blur' }
      ],
      serviceDeskIds: [
        { required: true, message: '请选择所属客服组', trigger: 'blur' }
      ],
      minConcurrentChatNumber: [
        { validator: checkMinChatNumber, trigger: 'blur' }
      ],
      maxConcurrentChatNumber: [
        { validator: checkMaxChatNumber, trigger: 'blur' }
      ]
    })

    const { validate, resetFields, validateInfos } = useForm(formData, rules);

    function checkDefaultServiceDesk (serviceDesks: Array<any>) {
      const index = serviceDesks.findIndex(item => item === formData.defaultServiceDesk.id)
      if (index === -1) {
        formData.defaultServiceDesk.id = null
      }
    }

    function handleTagChange (tags) {
      selectedTags.value = tags.map(tag => ({ id: tag.value }))
    }

    function handleCancel () {
      showModal.value = false
    }

    function handleSubmit () {
      validate().then(() => {
        if (props.selectedAccounts.length === 0) {
          message.error('至少选择一个客服')
          return
        }
        const engineer = JSON.parse(JSON.stringify(formData))
        engineer.serviceDesks = engineer.serviceDeskIds.map(id => ({ id }))
        engineer.user.tags = selectedTags.value
        const ids = props.selectedAccounts.map((item: any) => item.id).join(',')
        OpenOtherApi.batchUpdateEngineers({
          engineer,
          ids
        }).then(() => {
          resetFields()
          emit('refresh')
          showModal.value = false
          message.success('批量修改成功')
        })
      })
    }

    return {
      showModal,
      formData,
      validateInfos,
      filterRoleNameKey,
      checkDefaultServiceDesk,
      handleTagChange,
      handleCancel,
      handleSubmit,
      serviceDeskOptionIds
    }
  }
})
